const getDeviceStatusLabel = (status) => {
    const statuses = {
        ORDERED: 'Ordered',
        DELIVERED: 'Delivered',
        ACTIVATED: 'Activated',
        SETUP_NEEDED: 'Setup Needed',
        CONFIGURED: 'Configured',
        RETURN_NEEDED: 'Return Needed',
        EXCHANGED: 'Replacement ordered',
        CANCELLED: 'Cancelled',
        None: 'No device'
    };
    return status ? statuses[status] : 'N/A';
};
export default getDeviceStatusLabel;
